import { useEffect, useState } from 'react';
import { collection, query, orderBy, limit as qLimit, onSnapshot, where } from 'firebase/firestore';
import { db } from '../firebase.js';

/**
 * Live event stream. `filter` is one of:
 *   'all'         — no filter
 *   'humans'      — likely_human, confirmed_human, active_reading
 *   'confirmed'   — confirmed_human, active_reading
 *   'hot'         — active_reading only
 */
export function useLiveEvents({ filter = 'all', max = 200, campaignId } = {}) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const constraints = [orderBy('occurred_at', 'desc'), qLimit(max)];
    if (campaignId) constraints.unshift(where('campaign_id', '==', campaignId));
    const q = query(collection(db, 'events'), ...constraints);
    const unsub = onSnapshot(
      q,
      (snap) => {
        const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setEvents(applyFilter(rows, filter));
        setLoading(false);
      },
      (err) => {
        console.error('useLiveEvents', err);
        setLoading(false);
      },
    );
    return unsub;
  }, [filter, max, campaignId]);

  return { events, loading };
}

function applyFilter(rows, filter) {
  switch (filter) {
    case 'humans':
      return rows.filter((r) =>
        ['likely_human', 'confirmed_human', 'active_reading'].includes(r.classification),
      );
    case 'confirmed':
      return rows.filter((r) => ['confirmed_human', 'active_reading'].includes(r.classification));
    case 'hot':
      return rows.filter((r) => r.classification === 'active_reading');
    default:
      return rows;
  }
}
